import React from 'react'
import Registry from './Registry';
import getValue from 'lodash/get';
import { shouldShow } from '../util/prerequisites';
// value & values

const Field = ({ type, values, name, onChange, prerequisites, errors, ...fieldProps }) => {

  const Component = Registry.getField(type);

  if(!Component) {
    return <div>Component {type} not yet implemented</div>
  }
  const value = getValue(values, name);
  const error = getValue(errors, name);
  const errorMessage = Array.isArray(error) ? error[0] : error;
  const processedProps = {};

  if (!shouldShow(values, prerequisites)) {
    return null;
  }

  if(!Component) {
    <div className="nf-warning-no-exist">{type} field does not exist yet or is not loaded.</div>;
  }

  const parseExpression = v => {
    if(v === 'true') v = true;
    if(v === 'false') v = false;
    return v;
  }

  Object.keys(fieldProps).forEach(p => {
    processedProps[p] = parseExpression(fieldProps[p]);
  })

  return (
    <Component {...processedProps}
      name={name}
      value={value}
      values={values}
      errorMessage={errorMessage}
      onChange={onChange}/>
  );
} 

const Fields = ({
  fields = [],
  Registry,
  id, 
  ...rest
}) => {

  return (
    <>
      {fields.map((field, i) => <Field {...field}  {...rest} key={field.id || `${field.name}-${i}`} />)}
    </>
  );
}



Fields.spec = [{
  name: 'Fields',
  key: 'Fields',
  title: 'Collection of fields',
  fields: [{
    type: 'TextField',
    name: 'title',
    label: 'Section title',
  }, {
    type: 'TextField',
    name: 'navigation.previousLabel',
    label: 'Previous label',
    helperText: 'if there is a previous section, this will be the label to go back.'
  }, {
    type: 'TextField',
    name: 'navigation.nextLabel',
    label: 'Next label',
    helperText: 'if there is a next section, this will be the label to go forward.'
  }, {
    type: 'TextField',
    name: 'navigation.submitLabel',
    label: 'Submit label',
    helperText: 'If this section is the last section, this will be the text on the submit button.'
  }],
  defaultProperties: {
    title: 'Section title',
    navigation: {
      previousLabel: 'Previous',
      nextLabel: 'Next',
      submitLabel: 'Submit'
    }
  }
}];

Registry.addField('group', Fields);
Registry.addSection('Fields', Fields);

export default Fields;